<div class="corte-caja-container">
  <div class="header-actions">
    <h1>Corte de Caja</h1>
    <div class="header-buttons">
      <button mat-stroked-button color="primary" (click)="exportarPdf()" [disabled]="!cortes.length">
        <mat-icon>picture_as_pdf</mat-icon> Exportar PDF
      </button>
      <button mat-raised-button color="accent" (click)="abrirCorteDia()" *ngIf="isAdministrador" [disabled]="isLoading">
        <mat-icon>today</mat-icon> Corte de Hoy
      </button>
      <button mat-raised-button color="primary" (click)="abrirNuevoCorte()" *ngIf="isAdministrador">
        <mat-icon>add</mat-icon> Nuevo Corte
      </button>
    </div>
  </div>

  <!-- Filtros de fecha -->
  <mat-card class="filtros-card">
    <mat-card-content>
      <form [formGroup]="filtroForm" class="filtros-form">
        <mat-form-field appearance="outline">
          <mat-label>Fecha inicio</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Fecha fin</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
        <button mat-flat-button color="primary" (click)="cargarCortes()" [disabled]="isLoading">
          <mat-icon>search</mat-icon> Buscar
        </button>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Tarjetas de resumen -->
  <section class="summary-grid" *ngIf="cortes.length">
    <mat-card class="summary-card">
      <mat-icon color="primary">shopping_cart</mat-icon>
      <div>
        <h4>Total Ventas</h4>
        <span>{{ totalVentasPeriodo | currency }}</span>
      </div>
    </mat-card>
    <mat-card class="summary-card">
      <mat-icon color="accent">payments</mat-icon>
      <div>
        <h4>Efectivo Sistema</h4>
        <span>{{ totalEfectivoPeriodo | currency }}</span>
      </div>
    </mat-card>
    <mat-card class="summary-card" [class.diferencia-negativa]="diferenciaPeriodo < 0" [class.diferencia-positiva]="diferenciaPeriodo > 0">
      <mat-icon [color]="diferenciaPeriodo < 0 ? 'warn' : 'primary'">{{ diferenciaPeriodo < 0 ? 'trending_down' : 'trending_up' }}</mat-icon>
      <div>
        <h4>Diferencia Total</h4>
        <span>{{ diferenciaPeriodo | currency }}</span>
      </div>
    </mat-card>
    <mat-card class="summary-card">
      <mat-icon style="color:#4CAF50">receipt_long</mat-icon>
      <div>
        <h4>Cortes del Período</h4>
        <span>{{ cortes.length }}</span>
      </div>
    </mat-card>
  </section>

  <!-- Tabla de cortes -->
  <mat-card class="table-card">
    <mat-card-content>
      <div *ngIf="isLoading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando cortes...</p>
      </div>

      <div *ngIf="!isLoading && cortes.length === 0" class="empty-state">
        <mat-icon>point_of_sale</mat-icon>
        <h3>No hay cortes registrados</h3>
        <p>Crea un nuevo corte de caja para comenzar.</p>
        <button mat-raised-button color="primary" (click)="abrirNuevoCorte()" *ngIf="isAdministrador">
          <mat-icon>add</mat-icon> Nuevo Corte
        </button>
      </div>

      <div *ngIf="!isLoading && cortes.length > 0" class="table-wrapper">
        <table mat-table [dataSource]="cortes" class="cortes-table">

          <ng-container matColumnDef="fecha">
            <th mat-header-cell *matHeaderCellDef>Período</th>
            <td mat-cell *matCellDef="let c">
              <span class="fecha-text">{{ c.fechaInicio | date:'dd/MM/yy HH:mm' }}</span>
              <span class="fecha-sep">→</span>
              <span class="fecha-text">{{ c.fechaFin | date:'dd/MM/yy HH:mm' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef>Usuario</th>
            <td mat-cell *matCellDef="let c">{{ c.usuario?.name || c.usuario?.email || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="ventas">
            <th mat-header-cell *matHeaderCellDef>Ventas</th>
            <td mat-cell *matCellDef="let c">
              <span class="ventas-count">{{ c.cantidadVentas }}</span>
              <span class="ventas-total">{{ c.totalVentas | currency }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="efectivoSistema">
            <th mat-header-cell *matHeaderCellDef>Efectivo Sis.</th>
            <td mat-cell *matCellDef="let c">{{ c.totalEfectivo | currency }}</td>
          </ng-container>

          <ng-container matColumnDef="efectivoContado">
            <th mat-header-cell *matHeaderCellDef>Contado</th>
            <td mat-cell *matCellDef="let c">
              {{ c.efectivoContado != null ? (c.efectivoContado | currency) : '—' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="diferencia">
            <th mat-header-cell *matHeaderCellDef>Diferencia</th>
            <td mat-cell *matCellDef="let c">
              <span *ngIf="c.diferencia != null"
                [class.diff-neg]="c.diferencia < 0"
                [class.diff-pos]="c.diferencia > 0"
                [class.diff-zero]="c.diferencia === 0">
                {{ c.diferencia | currency }}
              </span>
              <span *ngIf="c.diferencia == null">—</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let c">
              <span class="estado-badge" [class.abierto]="c.estado === 'abierto'" [class.cerrado]="c.estado === 'cerrado'">
                {{ c.estado === 'cerrado' ? 'Cerrado' : 'Abierto' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let c">
              <button mat-icon-button color="primary" (click)="verDetalle(c)" matTooltip="Ver detalle">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="cerrarCorte(c)"
                *ngIf="isAdministrador && c.estado === 'abierto'"
                matTooltip="Cerrar corte">
                <mat-icon>lock</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
